import React from 'react';
import { browserHistory } from 'react-router';
import commonUtil from '../../utils/commonUtil';
const applicationRoutes = commonUtil.getApplicationRoutes();

class RedirectHandlerEventCreate extends React.Component {
  componentDidMount() {
    browserHistory.replace({
      pathname: applicationRoutes.home,
      state: { scrollToCategoryGrid: true },
    });
  }

  render() {
    return null;
  }
}

export default RedirectHandlerEventCreate;
